export default "__VITE_ASSET__z3bL_2P4__"